// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"UploadPdfs_errorMessage__12XAm","sectionTitle":"UploadPdfs_sectionTitle__26uRO"};